module.exports = __webpack_public_path__ + "static/media/Mastercard.3fe7290b.svg";